/**
 *  MissilePowerup
 *
 *  Created by Legman on 20/04/2017.
 *
 */

import MissilePowerup from "./MissilePowerup";
import SmartMissile from "./SmartMissile";

/**
 * @class
 * @extends Powerup
 */
export default class SmartMissilePowerup extends MissilePowerup {
    /**
     * @param collector
     */
    constructor(collector) {
        super(collector);
    }

    /**
     * @param {RaceCar} collector
     * @private
     */
    _createMissile(collector) {
        return new SmartMissile(collector);
    }
}